import Vue from 'vue'
import App from './App.vue'
import StorybookWordCloudPlugin from './storybookPlugin'

import '@/assets/scss/index.scss'
Vue.config.productionTip = false

Vue.use(StorybookWordCloudPlugin)
window.AHA_STORYBOOK_VERSION = StorybookWordCloudPlugin.version

new Vue({
  render: h => h(App),
}).$mount('#aha-wordcloud')
